export default __webpack_public_path__ + "static/media/suite-montanha1-6.52a14fe6.webp";